import React, { useState } from "react";
import { PUBLIC_URL } from 'utils/publicUrl';
import { useContext } from "react";
import { toast } from "Components/DesignSystem/Toast/useToast";
import AuthManager from "../../../../Common/AuthManager";
import { AppContext } from "../../../../Context/AppContext";
import ServiceWrapper from "../../../../Services/ServiceWrapper";
import AppSettings from "../../../../Settings/AppSettings";
import GMSBorderlessButton from "../../../Common/components/GMSBorderlessButton";
import Label from "../../../Common/components/Label";
import { formatDate } from "Common/HelperClass";

const PromotionView = ({ setShowPromotion, builders, refreshBuilder }) => {
  const liveBuilder = builders?.live?.builder;
  const draftBuilder = builders?.draft?.builder;
  const rollbackBuilder = builders?.rollback?.builder;
  let api_base_url = AppSettings.GMS_BACKEND_API_URL;
  const appData = useContext(AppContext);
  const [disableButton, setDisableButton] = useState(false);

  const [rollbackButtonTitle, setRollbackButtonTitle] = useState("Rollback");
  const [promoteButtonTitle, setPromoteButtonTitle] =
    useState("Publish to live");

  async function promoteBuilderToLive(builder_uid) {
    setDisableButton(true);
    setPromoteButtonTitle("Publish started ...");
    let res = await ServiceWrapper.doGet(
      `${api_base_url}/builder/${builder_uid}/promote`,
      null,
      null,
      AuthManager.getGmsToken()
    );
    if (res.data.done) {
      setPromoteButtonTitle("");
      toast.success(res.data.message);
      setDisableButton(false);
      setTimeout(() => {
        setShowPromotion(false);
        refreshBuilder();
      }, 500);
    } else {
      setDisableButton(false);
      setPromoteButtonTitle("Publish to live");
      toast.error(res.data.message);
    }
  }

  async function rollbackOldBuilder(builder_uid) {
    setDisableButton(true);
    setRollbackButtonTitle("Rollback started ...");
    let res = await ServiceWrapper.doGet(
      `${api_base_url}/builder/${builder_uid}/rollback`,
      null,
      null,
      AuthManager.getGmsToken()
    );

    if (res.data.done) {
      toast.success(res.data.message);
      setRollbackButtonTitle("");
      setDisableButton(false);
      setTimeout(() => {
        setShowPromotion(false);
        refreshBuilder();
      }, 500);
    } else {
      setRollbackButtonTitle("Rollback");
      setDisableButton(false);
      toast.error(res.data.message);
    }
  }

  return (
    <React.Fragment>
      <div
        className="bg-white container ps-0"
        style={{
          top: "60px",
          width: "34%",
          right: "-25px",
          bottom: "0px",
          overflowY: "scroll",
          position: "fixed",
          zIndex: 4,
          boxShadow: "0 2px 4px 0 rgba(116, 116, 116, 0.15)",
        }}
      >
        <div className="">
          <div
            className=" d-flex justify-content-between pe-3 ps-3"
            style={{
              height: "65px",
            }}
          >
            <span className="align-self-center fs-5 fw-bold mb-0 pt-2">
              Publish to Live
            </span>
            <button
              data-testid="builder-promotion-close-btn"
              aria-label="Close"
              className="align-self-center border-0 btn fw fw-light mb-1 me-1 shadow-none"
              onClick={() => {
                setShowPromotion(false);
              }}
            >
              <img
                className="promotion-close-icon mt-3"
                src={PUBLIC_URL + "/img/new-close-icon.svg"}
                alt="Close icon"
              />
            </button>
          </div>
        </div>
        <div className="p-3">
          {builders.live !== null && (
            <Builder
              builder={liveBuilder}
              label=""
              chip="chip-live"
              showButton={false}
              buildType={"Live"}
            />
          )}

          {builders.draft !== null && (
            <Builder
              builder={draftBuilder}
              label={promoteButtonTitle}
              chip="chip-draft"
              onClick={() => {
                if (appData.pm.checkPermission("gmskbcapps_publish")) {
                  promoteBuilderToLive(draftBuilder.uid);
                } else {
                  toast.info(
                    "You don't have permission to publish/promote the builder"
                  );
                }
              }}
              buildType={"Draft"}
            />
          )}

          {builders.rollback && (
            <Builder
              builder={rollbackBuilder}
              label={rollbackButtonTitle}
              disableButton={disableButton}
              chip="chip-old"
              onClick={() => {
                if (appData.pm.checkPermission("gmskbcapps_publish")) {
                  rollbackOldBuilder(rollbackBuilder.uid);
                } else {
                  toast.info(
                    "You don't have permission to rollback the builder"
                  );
                }
              }}
              buildType={"Old"}
            />
          )}
        </div>
      </div>
    </React.Fragment>
  );
};

const Builder = ({
  builder,
  label,
  disableButton,
  chip,
  showButton = true,
  onClick,
  buildType,
}) => {
  return (
    <div className="mt-4">
      <div className="d-flex justify-content-between">
        <div className="d-inlinealign-items-center">
          <Label
            message={builder.name}
            fontSize={"0.875"}
            fontWeight={"400"}
            color={"#091CAA"}
          />
          &nbsp;
          <span className={`badge ps-2 pe-2 chip ${chip}`}>{buildType}</span>
        </div>
        {showButton && (
          <div style={{ alignSelf: "center" }}>
            <GMSBorderlessButton
              name={label}
              fontSize={"14px"}
              onClick={onClick}
              disabled={disableButton}
            />
          </div>
        )}
      </div>

      <div className="pb-1 date-style">{formatDate(builder.created_at)}</div>
    </div>
  );
};

export default PromotionView;
